import React, { useState, Fragment, useEffect, useRef } from 'react';
import {
  Input,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  CustomInput,
} from 'reactstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AxiosAPI } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Contacts } from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export default function ContactsForm({ contacts, id, name, visible, toggle }) {
  const [inputFields, setInputFields] = useState(
    contacts.filter(
      (x) =>
        x.type !== 'DailyTickets' &&
        x.type !== 'WeeklyTickets' &&
        x.type !== 'MonthlyTickets'
    )
  );
  const [allContacts, setAllContacts] = useState(
    contacts.filter(
      (x) =>
        x.type === 'DailyTickets' ||
        x.type === 'WeeklyTickets' ||
        x.type === 'MonthlyTickets'
    )
  );
  const [isEditing, setIsEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [newlyAddedRowIndex, setNewlyAddedRowIndex] = useState(null);
  const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
  const rowsScrollRef = useRef(null);
  const rowRefs = useRef({});
  const typeInputRefs = useRef({});

  useEffect(() => {
    if (newlyAddedRowIndex === null) {
      return undefined;
    }

    const rowEl = rowRefs.current[newlyAddedRowIndex];
    const typeInputEl = typeInputRefs.current[newlyAddedRowIndex];

    if (rowsScrollRef.current && rowEl) {
      const scrollTop = Math.max(rowEl.offsetTop - 10, 0);
      rowsScrollRef.current.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }

    const focusTimer = setTimeout(() => {
      if (typeInputEl && typeof typeInputEl.focus === 'function') {
        typeInputEl.focus();
      }
    }, 120);

    setHighlightedRowIndex(newlyAddedRowIndex);
    const clearHighlightTimer = setTimeout(() => {
      setHighlightedRowIndex(null);
      setNewlyAddedRowIndex(null);
    }, 1600);

    return () => {
      clearTimeout(focusTimer);
      clearTimeout(clearHighlightTimer);
    };
  }, [newlyAddedRowIndex]);

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      type: 'DailyAnalytics',
      name: '',
      email: '',
      phoneNumber: '',
      isBcc: false,
    });
    setInputFields(values);
    setNewlyAddedRowIndex(values.length - 1);
    setIsEditing(true);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
    setIsEditing(true);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === 'name') {
      values[index].name = event.target.value;
    } else if (event.target.name === 'email') {
      values[index].email = event.target.value;
    }
    //  else if (event.target.name === 'phoneNumber') {
    //   values[index].phoneNumber = event.target.value;
    // }
    else {
      values[index].type = event.target.value;
    }

    setInputFields(values);
    setIsEditing(true);
  };

  const handleCheckChange = (index, e) => {
    const values = [...inputFields];
    if (e.target.checked) {
      values[index].isBcc = true;
    } else {
      values[index].isBcc = false;
    }
    setInputFields(values);
    setIsEditing(true);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      contacts: [...inputFields, ...allContacts],
      updater: 'admin',
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Contacts}/${id}`,
      data,
    }).then((res) => {
      // console.log(461, res.data)
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        setTimeout(() => {
          NotificationManager.success(
            '',
            'Contacts updated successfully.',
            3000,
            null,
            null,
            'success'
          );
          window.location.reload();
        }, 300);
      }
    });
  };

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="xl"
        modalClassName="contacts-scroll-modal"
      >
        <div className="contacts-modal-header">
          <div className="contacts-modal-heading">
            <div className="contacts-modal-icon">
              <i className="iconsminds-bell" />
            </div>
            <div>
              <h2>Subscribe to Reports & Alerts</h2>
              <p>{name}</p>
            </div>
          </div>
          <button
            type="button"
            className="contacts-modal-close"
            onClick={toggle}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <ModalBody className="contacts-modal-body">
          <div className="contacts-top-actions">
            <Button
              onClick={handleAddFields}
              color="primary"
              size="xs"
              className="contacts-add-button"
            >
              + Add Email
            </Button>
          </div>

          <div className="contacts-rows-scroll" ref={rowsScrollRef}>
            <div className="contacts-table-header-row contacts-table-grid">
              <div className="contacts-table-cell">Type</div>
              <div className="contacts-table-cell">Name</div>
              <div className="contacts-table-cell">Email</div>
              <div className="contacts-table-cell contacts-table-cell--center">
                BCC
              </div>
              <div className="contacts-table-cell contacts-table-cell--center">
                Remove
              </div>
            </div>

            {inputFields != null &&
              inputFields.map((contact, index) => (
                <div
                  key={index}
                  ref={(el) => {
                    if (el) {
                      rowRefs.current[index] = el;
                    }
                  }}
                  className={`contacts-table-row contacts-table-grid ${
                    highlightedRowIndex === index
                      ? 'contacts-row-highlight'
                      : ''
                  }`}
                >
                  <div className="contacts-table-cell">
                    <Input
                      innerRef={(el) => {
                        if (el) {
                          typeInputRefs.current[index] = el;
                        }
                      }}
                      className="contacts-cell-input"
                      type="select"
                      value={contact.type}
                      name="type"
                      onChange={(event) => handleInputChange(index, event)}
                    >
                      {/* <option value="NewTickets">Booking Desk Tickets</option>
                      <option value="Conference">Conference Enquiries</option> */}
                      <option value="DailyAnalytics">Daily Analytics</option>
                      {/* <option value="FrontDeskTickets">
                        Front Desk Tickets
                      </option>
                      <option value="GroupBooking">Group Booking</option>
                      <option value="LongStay">Long Stay</option>
                      <option value="MissingResponses">
                        Missing Responses
                      </option>
                     
                      <option value="Reservations">Reservations</option> */}
                      <option value="WeeklyAnalytics">Weekly Analytics</option>
                      <option value="MonthlyAnalytics">
                        Monthly Analytics
                      </option>
                      <option value="UsageAlerts">Usage Alerts</option>
                      {/* <option value="FoodBeverage">Food & Beverage</option> */}
                    </Input>
                  </div>
                  <div className="contacts-table-cell">
                    <Input
                      className="contacts-cell-input"
                      type="text"
                      name="name"
                      value={contact.name}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </div>
                  <div className="contacts-table-cell">
                    <Input
                      className="contacts-cell-input"
                      type="text"
                      name="email"
                      min={1}
                      value={contact.email}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </div>
                  {/* <Colxx sm={2} className="mb-3">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      min={1}
                      value={contact.phoneNumber}
                      onChange={(event) => handleInputChange(index, event)}
                    />
                  </Colxx> */}
                  <div className="contacts-table-cell contacts-table-cell--center">
                    <CustomInput
                      type="checkbox"
                      className="contacts-bcc-checkbox"
                      id={index}
                      defaultChecked={contact.isBcc}
                      name="isBcc"
                      onChange={(event) => handleCheckChange(index, event)}
                    />
                  </div>

                  <div className="contacts-table-cell contacts-table-cell--center">
                    <Button
                      onClick={() => handleRemoveFields(index)}
                      color="secondary"
                      size="xs"
                      outline
                      className="contacts-remove-button"
                    >
                      -
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        </ModalBody>
        <ModalFooter className="contacts-modal-footer">
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            <IntlMessages id="pages.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
